module.exports = __webpack_public_path__ + "img/t_3.faa23d24.jpg";